/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyCounselorPatchCounselingRequestExaminerTypename =
  "PharmacyCounselorPatchCounselingRequestExaminer" as const;

/**
 *
 * @export
 * @interface PharmacyCounselorPatchCounselingRequestExaminer
 */
export interface PharmacyCounselorPatchCounselingRequestExaminer {
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorPatchCounselingRequestExaminer
   */
  dateOfBirth?: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyCounselorPatchCounselingRequestExaminer
   */
  gender?: PharmacyCounselorPatchCounselingRequestExaminerGenderEnum;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCounselorPatchCounselingRequestExaminer
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PharmacyCounselorPatchCounselingRequestExaminerGenderEnum {
  Male = "male",
  Female = "female",
  None = "none",
}

export function PharmacyCounselorPatchCounselingRequestExaminerFromJSON(
  json: any
): PharmacyCounselorPatchCounselingRequestExaminer {
  return PharmacyCounselorPatchCounselingRequestExaminerFromJSONTyped(json, false);
}

export function PharmacyCounselorPatchCounselingRequestExaminerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyCounselorPatchCounselingRequestExaminer {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCounselorPatchCounselingRequestExaminerTypename,

    dateOfBirth: !exists(json, "date_of_birth") ? undefined : json["date_of_birth"],
    gender: !exists(json, "gender") ? undefined : json["gender"],
  };
}

export function PharmacyCounselorPatchCounselingRequestExaminerToJSON(
  object?: PharmacyCounselorPatchCounselingRequestExaminer | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    date_of_birth: value.dateOfBirth,
    gender: value.gender,
  };
}
